/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable react/no-string-refs */
import React, { useState, useCallback } from 'react';
import _ from 'underscore';
import { PropTypes } from 'prop-types';
import { Dialog, DialogType, DialogFooter, Dropdown, PrimaryButton, DefaultButton } from '@fluentui/react';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { getStepStyles } from '@bingads-webui-campaign-react/conversion-wizard-components';

import { textWrapDropdownStyles } from '../../shared/overflow-dropdown-styles';

const TagSelectionDialogUnStyled = (props) => {
  const {
    hiddenDefault,
    onSaveDialog,
    onDismissDialog,
    tagOptions,
    selectedTag,
    i18n,
    classes,
    isClarityGoal,
  } = props;
  const [tagId, setTagId] = useState(selectedTag.Id);
  const [tagName, setTagName] = useState(selectedTag.Name);

  const dialogContentProps = {
    type: DialogType.normal,
    title: i18n.getString(_TL_('Use a different tag')),
  };

  const tagHelpLink = i18n.getString(_TL_('here\'s how to do so.'));

  const handleSave = useCallback(() => {
    onSaveDialog({ Id: tagId, Name: tagName });
  }, [onSaveDialog, tagId, tagName]);

  const handleDismiss = useCallback(() => {
    onDismissDialog();
  }, [onDismissDialog]);

  const onChangeSelection = useCallback((event, option) => {
    setTagId(option.key);
    setTagName(option.text);
  }, []);

  return (
    <Dialog
      hidden={hiddenDefault}
      onDismiss={handleDismiss}
      dialogContentProps={dialogContentProps}
      modalProps={{
        layerProps: {
          styles: {
            root: {
              zIndex: 1000,
            },
          },
        },
      }}
    >
      <div className={classes.tagDialogText}>
        <p>{i18n.getString(_TL_('You only need one tag in most cases, even for different websites. We recommend using your exisiting tag. But if you still want to create another tag,'))}
          <button className="HelpTopic clickable btn-link" query="help:app54493" aria-label={tagHelpLink}>{` ${tagHelpLink}`}</button>
        </p>
        <p>{isClarityGoal && i18n.getString(_TL_('Changing the tag will also remove your previous code-free Clarity event setup. You will need to set it up again for your conversions to continue working.'))}</p>
      </div>

      <div>
        <Dropdown
          label={i18n.getString(_TL_('Tag'))}
          selectedKey={tagId}
          options={tagOptions}
          onChange={onChangeSelection}
          dropdownWidth={0}
          styles={textWrapDropdownStyles}
        />
      </div>
      <DialogFooter>
        <PrimaryButton onClick={handleSave} text={i18n.getString(_TL_('Save'))} />
        <DefaultButton onClick={handleDismiss} text={i18n.getString(_TL_('Cancel'))} />
      </DialogFooter>
    </Dialog>
  );
};

TagSelectionDialogUnStyled.propTypes = {
  hiddenDefault: PropTypes.bool.isRequired,
  onSaveDialog: PropTypes.func.isRequired,
  onDismissDialog: PropTypes.func.isRequired,
  tagOptions: PropTypes.arrayOf({}).isRequired,
  isClarityGoal: PropTypes.bool.isRequired,
  selectedTag: PropTypes.shape({
    Id: PropTypes.number.isRequired,
    Name: PropTypes.string.isRequired,
  }).isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  classes: PropTypes.shape(_.mapObject(
    getStepStyles(),
    _.constant(PropTypes.string.isRequired)
  )).isRequired,
};

export const TagSelectionDialog = withDefaultStyles(TagSelectionDialogUnStyled, getStepStyles);
